(() => {
  const init = root => {
    (root || document).querySelectorAll('[data-hh-mr-slider]').forEach(slider => {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      const rail = slider.querySelector('[data-hh-mr-rail]');
      slider.querySelectorAll('[data-hh-mr-slide]').forEach(button => {
        button.addEventListener('click', () => {
          const direction = Number(button.dataset.hhMrSlide || 1);
          rail.scrollBy({ left: direction * rail.clientWidth * .82, behavior: 'smooth' });
        });
      });
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => init()) : init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

